import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#23BDEE",
  d: "M22.575 12.81a1 1 0 0 1 0 1.714L1.515 27.189A1 1 0 0 1 0 26.332V1.002A1 1 0 0 1 1.515.143z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }